module.exports = __webpack_public_path__ + "static/media/aeronautical-eng.1b2bf062.jpg";